export const auditReportJA = {
  'New Report': 'New Report',
  'Edit Fields': 'Edit Fields',
  Print: 'Print',
  Export: 'Export',
  'Item Type': 'Item Type',
  'Item Name': 'Item Name',
  'Field Name': 'Field Name',
  'Old Value': 'Old Value',
  'New Value': 'New Value',
  'User': 'User',
  'Date and Time': 'Date and Time',
  'Show Records From:': 'Show Records From:',
  'To:': 'To:',
  Cancel: 'Cancel',
  Ok: 'OK',
  Cancel: 'Cancel',
  Preparing: 'Preparing',
  'Text (Tab Delimited)': 'Text (Tab Delimited)',
  'Text (Comma Delimited)': 'Text (Comma Delimited)',
  'Text (Other)': 'Text (Other)',
  'Excel (xls)': 'Excel (xls)',
  'Excel (xlsx)': 'Excel (xlsx)',
  'Include Column Headings': 'Include Column Headings',
  Exporting: 'Exporting',
  Options: 'Options',
  Delimiter: 'Delimiter',
  Settings: 'Settings',
  'Newline Handling for Text Fields': 'Newline Handling for Text Fields',
  'Show Updates for:': 'Show Updates for:',
  'Item Name:': 'Item Name:',
  'Pedigree Data': 'Pedigree Data',
  'Individual Data': 'Individual Data',
  Add: 'Add',
  'Field Chooser': 'Field Chooser',
  'Search for Fields': 'Search for Fields',
  'Validation error': 'Validation error',
  'Please select at least one field in the "Show Updates for" section': 'Please select at least one field in the "Show Updates for" section',
  'Audit Fields': 'Audit Fields',
  'Failed to save result': 'Failed to save result',
  'Failed to get fields': 'Failed to get fields',
  'Select All': 'Select All',
  'Clear All': 'Clear All',
  'Loading': 'Loading',
  'Failed to export data': 'Failed to export data',
  'Failed to run new report': 'Failed to run new report',
};